import { marxy } from '../initMarxy'
import { safeMarxyCall } from '../helpers'
import { MarxyEvents } from '~/utils/marxy/types'

const SESSION_PING_INTERVAL = 2 * 60 * 1000 // A two minute interval is required between session pings

/**
 * Tracks an active client by dispatching a ping every 2 minutes
 *
 * IMPORTANT
 * This function is private, it is called after the page load (see eventTracking.js)
 * and is NOT connected to the Marxy SDK (window.marxy.eventTracking)
 * Never call this function directly. This would wrap the function in a bad JS chunk,
 * duplicate the initialization of the Marxy SDK, and possibly incorrect behaviour.
 */
// TODO: Use RequestAnimationFrame or Page Visibility API (prevent send in inactive tab)
const trackSessionPing = () => {
  safeMarxyCall(() => {
    marxy.trackEvent(MarxyEvents.SESSION_PING)
    setTimeout(() => trackSessionPing(), SESSION_PING_INTERVAL)
  })
}

export default trackSessionPing
